var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,37.5c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15c-8.3,0-15,6.7-15,15C7.5,30.8,14.2,37.5,22.5,37.5z  M22.5,8.8c7.6,0,13.7,6.1,13.7,13.7s-6.1,13.7-13.7,13.7S8.8,30.1,8.8,22.5S14.9,8.8,22.5,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.5,36.2c7.6,0,13.7-6.1,13.7-13.7S30.1,8.8,22.5,8.8S8.8,14.9,8.8,22.5S14.9,36.2,22.5,36.2z M14.8,18.2 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S14.8,19.3,14.8,18.2z M26.2,18.2c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S26.2,19.3,26.2,18.2 z M28.5,27.2c-0.1,0.3-0.3,0.6-0.7,0.6H17.2c-0.4,0-0.6-0.3-0.7-0.6c0-0.4,0.3-0.7,0.7-0.7h10.6C28.2,26.5,28.5,26.8,28.5,27.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 16.8,
    cy: 18.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 28.2,
    cy: 18.2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.2,26.5c-0.4,0-0.7,0.3-0.7,0.7c0.1,0.3,0.3,0.6,0.7,0.6h10.6c0.4,0,0.6-0.3,0.7-0.6 c0-0.4-0.3-0.7-0.7-0.7H17.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralFace);
export default __webpack_public_path__ + "static/media/neutral_face.936b8a42bdbe3ea78fd7b44ce8be74d5.svg";
export { ForwardRef as ReactComponent };